import React, { useState, useEffect } from 'react';
import { Empty, Button, Pagination, Checkbox, Space, Dropdown, Menu, Input, Divider, Badge, Select } from 'antd';
import {
  UserOutlined,
  PlusOutlined,
  CaretDownOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
  ExportOutlined,
  ImportOutlined,
  EditOutlined,
  FilterOutlined,
  CaretUpOutlined, SearchOutlined
} from '@ant-design/icons';
import { Loadding } from '../';

import './style';
const { Search } = Input;
export default React.forwardRef((props, ref) => {
  const {
    showNewLabel, showFilter, showView, optionView, currentView, showFooter,
    setSelectedCallback, relation, isLoadding,
    setPageCallback, onNew, newDisabled, title, rows, newLabel, newOptionMenu,
    total_rows, optionMenu, groupedBy,
    hasCheckbox, expandable, expand,
    bordered, selectMode, header,
    onSearch,
    onSearchPlaceHolder,
    searchWidth,
    isLayoutFixed
  } = props;
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  useEffect(() => {
    if (!setSelectedCallback) return;
    const arr = [];
    for (let i = 0; i < selected.length; i++) {
      if (selected[i] === true) {
        arr.push(i);
      }
    }
    setSelectedCallback(arr);
  }, [selected]);
  //const rows = rows.slice((page-1)*pageSize, page*pageSize);
  const onChangePage = (page, pageSize) => {
    setSelected([]);
    if (setPageCallback) {
      setPageCallback(page, pageSize);
    }
    setPage(page);
  }

  const onChangePageSize = (pageSize) => {
    setPageSize(pageSize);
    const maxPage = Math.ceil(total_rows / pageSize);
    if (page > maxPage) {
      setPage(maxPage);
      setPageCallback(maxPage, pageSize);
    } else {
      if (setPageCallback) {
        setPageCallback(page, pageSize);
      }
    }
  }
  const setExpandedByIndex = (index) => {
    const value = [].concat(expanded);
    value[index] = !expanded[index];
    setExpanded(value);
  }

  const setSelectedIndex = (index, checked) => {
    const value = [].concat(selected);
    value[index] = checked;
    setSelected(value);
  }

  const isSelectedAll = rows.length > 0 && selected.filter(x => x === true).length === rows.length;
  const menu = (
    <Menu>
      <Menu.Item key="1" icon={<UserOutlined />}>
        1st menu item
      </Menu.Item>
      <Menu.Item key="2" icon={<UserOutlined />}>
        2nd menu item
      </Menu.Item>
      <Menu.Item key="3" icon={<UserOutlined />}>
        3rd menu item
      </Menu.Item>
    </Menu>
  );

  const io = (
    <Menu>
      {/* <Menu.Item key="1" icon={<ImportOutlined />}>
        <span style={{ padding: '0 1rem' }}>导 入</span>
      </Menu.Item>
      <Menu.Item key="2" icon={<ExportOutlined />}>
        <span style={{ padding: '0 1rem' }}>导 出</span>
      </Menu.Item> */}
    </Menu>
  );
  const onSelectAll = () => {
    if (!isSelectedAll) {
      const arr = [];
      for (let i = 0; i < rows.length; i++) {
        arr.push(true);
      }
      setSelected(arr);
    } else {
      setSelected([]);
    }
  }

  const renderRow = (row, index) => {
    const arr = [];
    arr.push(
      <tr style={{ backgroundColor: row.row_bg }}>
        <td className={"sticky-td"} style={{ left: 0 }}>
          {expandable && (<Button
            onClick={() => setExpandedByIndex(index)}
            style={{ margin: '0 0.25rem 0 0' }}
            type="text"
            size="small"
            icon={expanded[index] ? <UpOutlined /> : <DownOutlined />} />)}
          {hasCheckbox && <Checkbox
            checked={row.selected}
            onChange={(e) => setSelectedIndex(index, e.target.checked)}>{pageSize * (page - 1) + index + 1}
          </Checkbox>}
          {!hasCheckbox && <span>{pageSize * (page - 1) + index + 1}</span>}
        </td>
        {
          header.map((column, j) => {
            const rel = (relation || {})[column.item];
            if (rel) {
              return <td className={header[j].sticky ? "sticky-td" : "td"} style={{ left: header[j].stickyLeft, right: header[j].stickyRight }} align={column.align}>{(rel.data.find(x => x.id === row[column.item]) || {})[rel.field]}</td>
            } else {
              let content = row[column.item];
              if (column.render) {
                content = column.render(content, row, index);
              }
              return <td className={header[j].sticky ? "sticky-td" : "td"} style={{ left: header[j].stickyLeft, right: header[j].stickyRight }} align={column.align}>{content}</td>
            }
          })
        }
      </tr>
    );
    arr.push(
      <tr hidden={!expanded[index]}>
        <td colspan={header.length + 2}>
          {expanded[index] && expand(row, index)}
        </td>
      </tr>
    )
    return arr;
  }
  const selectedCount = rows.filter(x => x.selected === true).length;

  return (
    <div className="table-container">
      <div className="table-container-header">
        <div className="header-title">
          {title}
        </div>
        <Divider type="vertical" style={{ height: '2rem', margin: '0 1.5rem' }} />
        <Space size="large">
          {
            selectedCount <= 0 && showFilter &&
            <Search style={{ width: searchWidth }} placeholder={onSearchPlaceHolder} allowClear onSearch={onSearch} />
          }
        </Space>
        <div style={{ marginLeft: 'auto' }}></div>
        <Space size="large">
          {
            (selectedCount === 0 && showView) && <Dropdown placement="bottomLeft"
              className="header-item" overlay={optionView}>
              <Button>
                <UnorderedListOutlined />
                <span style={{ padding: '0 1rem' }}>{currentView ? currentView : '--默认视图--'}</span> <DownOutlined />
              </Button>
            </Dropdown>
          }
          {
            selectedCount > 0 && [optionMenu]
          }
          {
            (showNewLabel && newOptionMenu) && <div>
              <Dropdown.Button className="header-item" overlay={newOptionMenu} disabled={newDisabled} onClick={onNew} style={{ backgroundColor: '#f0f0f0f' }} type="primary" icon={<CaretDownOutlined />} >
                <PlusOutlined />
                <span style={{ padding: '0 1rem' }}>{newLabel}</span>
              </Dropdown.Button>
            </div>
          }
          {
            (showNewLabel && !newOptionMenu) && <div>
              <Button className="header-item" onClick={onNew} disabled={newDisabled} style={{ backgroundColor: '#f0f0f0f' }} type="primary" >
                <PlusOutlined />
                <span style={{ padding: '0 1rem' }}>{newLabel}</span>
              </Button>
            </div>
          }
        </Space>
      </div>
      <div style={{ width: '100%', overflow: 'auto' }}>
        <table className={"table table-bordered" + (isLayoutFixed ? ' table-fixed' : '')} >
          <thead>
            <tr>
              <th className="sticky-th" width={expandable ? "105px" : "68px"} style={{ left: 0 }}>
                {expandable && <span style={{ margin: '0 1rem 0 0' }} />}
                {hasCheckbox && <Checkbox checked={isSelectedAll} onClick={onSelectAll}>#</Checkbox>}
                {!hasCheckbox && <span>#</span>}
              </th>
              {
                (header || []).map(item => {
                  if (item.width) {
                    return (<th className={item.sticky ? "sticky-th" : "th"} style={{ left: item.stickyLeft, right: item.stickyRight }} width={item.width}>{item.label}
                      {item.sortable && <CaretUpOutlined />}
                    </th>)
                  } else {
                    return (<th className="th" >{item.label}
                      {item.sortable && <CaretUpOutlined />}
                    </th>)
                  }
                })
              }
            </tr>
          </thead>
          {
            (rows || []).length > 0 && (
              <tbody className="table-hover" style={{ position: 'relative' }}>
                {
                  (rows || []).map((item, index) => {
                    return renderRow(item, index);
                  })
                }
              </tbody>
            )
          }
          {
            (rows || []).length > 0 && showFooter && !isLayoutFixed && (
              <tfoot>
                <tr>
                  <td colspan="99" className="td">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>显示第<strong> {(page - 1) * pageSize + 1} </strong>到<strong> {(page - 1) * pageSize + rows.length} </strong>条记录，总共<strong> {total_rows} </strong>条记录，每页显示<strong>
                        <Select onSelect={onChangePageSize} value={pageSize}>
                          <Select.Option value={10}>10</Select.Option>
                          <Select.Option value={20}>20</Select.Option>
                          <Select.Option value={50}>50</Select.Option>
                          <Select.Option value={100}>100</Select.Option>
                        </Select> </strong>条记录</div>
                      <Pagination onChange={onChangePage} style={{ marginLeft: 'auto' }} pageSize={pageSize} current={page} showSizeChanger={false} total={total_rows} />
                    </div>
                  </td>
                </tr>
              </tfoot>
            )
          }

          {
            !isLoadding && (rows || []).length === 0 && (
              <td colspan={99} style={{ padding: '10rem' }}>
                <Empty />
              </td>
            )
          }
          {
            isLoadding && (rows || []).length === 0 && (
              <td colspan={99} style={{ padding: '10rem' }}>
                <Loadding />
              </td>
            )
          }
        </table>
        {
          (rows || []).length > 0 && showFooter && isLayoutFixed && (
            <div style={{ backgroundColor: '#f2f2f5', padding: '0 24px', marginTop: '16px', position: 'fixed', right: 0, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'hidden' }}>
              <div style={{ backgroundColor: 'white', padding: '4px 16px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>显示第<strong> {(page - 1) * pageSize + 1} </strong>到<strong> {(page - 1) * pageSize + rows.length} </strong>条记录，总共<strong> {total_rows} </strong>条记录，每页显示<strong>
                  <Select onSelect={onChangePageSize} value={pageSize}>
                    <Select.Option value={10}>10</Select.Option>
                    <Select.Option value={20}>20</Select.Option>
                    <Select.Option value={50}>50</Select.Option>
                    <Select.Option value={100}>100</Select.Option>
                  </Select> </strong>条记录</div>
                <Pagination onChange={onChangePage} style={{ marginLeft: 'auto' }} pageSize={pageSize} current={page} showSizeChanger={false} total={total_rows} />
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
});
